import React, { useEffect } from "react";
import { Modal, Form, Input, App } from "antd";
import { useDispatch } from "react-redux";
import {
  createOrUpdateDepartment,
  fetchDepartmentsList,
} from "../departmentsThunks";

const DepartmentFormModal = ({ open, onClose, edit, onSuccess }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        department_name: edit.department_name,
      });
    } else {
      form.resetFields();
    }
  }, [edit, open]);

  const onFinish = async (values) => {
    try {
      await dispatch(
        createOrUpdateDepartment({
          department_name: values.department_name.trim(),
          department_id: edit?.department_id || 0,
          action: edit ? "update" : "create",
        })
      ).unwrap();

      message.success(
        edit ? "Department updated" : "Department created"
      );

      dispatch(fetchDepartmentsList());

      // ✅ send created name back
      onSuccess?.(values.department_name.trim());

      onClose();
    } catch (err) {
      message.error(err?.message || "Failed");
    }
  };

  return (
    <Modal
      open={open}
      title={edit ? "Edit Department" : "New Department"}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText={edit ? "Save" : "Create"}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        requiredMark
      >
        <Form.Item
          label="Department Name"
          name="department_name"
          rules={[{ required: true, message: "Department name is required" }]}
        >
          <Input placeholder="Enter department name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DepartmentFormModal;
